import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import { connect } from "react-redux"
import { browserHistory } from "react-router"
import { glAccountsDataWithId, sortGLAccounts, validateTextState, VALIDATION_TYPE } from "../../../lib/utils"
import { blockingFetchService } from "../../../lib/blockingFetch"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import CloseableProcessesStatus from "../../fragments/CloseableProcessesStatus"
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import FormControlInlineSelect from "../../fragments/FormControl.Inline.Select"
import FormControlInlineCheckbox from "../../fragments/FormControl.Inline.Checkbox"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import ButtonUpdate from "../ButtonUpdate"
import FormButtons from "../../fragments/FormButtons"

class CustomAccountingForm extends React.Component {

  state = {
    accountToDebitDisb: '',
    accountToCreditDisb: '',
    accountToDebitRep: '',
    accountToCreditRep: '',
    accountToCreditVAT: '',
    disabled: false,

    accountToDebitDisbValidationState: VALIDATION_TYPE.NULL,
    accountToCreditDisbValidationState: VALIDATION_TYPE.NULL,
    accountToDebitRepValidationState: VALIDATION_TYPE.NULL,
    accountToCreditRepValidationState: VALIDATION_TYPE.NULL,
    accountToCreditVATValidationState: VALIDATION_TYPE.NULL,

    running: false,
    success: false,
    error: null,
    closeStatuses: false,
  }

  isUpdate = this.props.isUpdate
  uri = '/customaccounting'
  text = 'Custom Loan Accounting'
  info = 'Custom Loan integration with accounting using selling price of bundles'

  componentDidMount() {
    this.props.loadGlAccounts()
    this.loadCustomAccounting()
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutId)
  }

  loadCustomAccounting = () => {

    this.setState({
      running: true,
      error: null,
      closeStatuses: false,
    })

    blockingFetchService(
      accessToken => apiServerApi.getCustomLoanAccountingRule(accessToken),
      data => this.dataLoaded(data),
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  dataLoaded = data => {

    if (!data) return

    const { accountToDebitOnDisbursal: { id: accountToDebitDisb },
      accountToCreditOnDisbursal: { id: accountToCreditDisb },
      accountToDebitOnRepayment: { id: accountToDebitRep },
      accountToCreditOnRepayment: { id: accountToCreditRep },
      accountToCreditVAT,
      disabled } = data,

    // NB: accountToCreditVAT can be null
    accountToCreditVATId = accountToCreditVAT ? accountToCreditVAT.id : ''

    this.setState({
      accountToDebitDisb,
      accountToCreditDisb,
      accountToDebitRep,
      accountToCreditRep,
      accountToCreditVAT: accountToCreditVATId,
      disabled
    })
  }

  accountToDebitDisbChanged = accountToDebitDisb => this.setState({
    accountToDebitDisb,
    accountToDebitDisbValidationState: validateTextState(accountToDebitDisb, false),
    error: null,
  })

  accountToCreditDisbChanged = accountToCreditDisb => this.setState({
    accountToCreditDisb,
    accountToCreditDisbValidationState: validateTextState(accountToCreditDisb, false),
    error: null,
  })

  accountToDebitRepChanged = accountToDebitRep => this.setState({
    accountToDebitRep,
    accountToDebitRepValidationState: validateTextState(accountToDebitRep, false),
    error: null,
  })

  accountToCreditRepChanged = accountToCreditRep => this.setState({
    accountToCreditRep,
    accountToCreditRepValidationState: validateTextState(accountToCreditRep, false),
    error: null,
  })

  accountToCreditVATChanged = accountToCreditVAT => this.setState({
    accountToCreditVAT,
    accountToCreditVATValidationState: validateTextState(accountToCreditVAT, false),
    error: null,
  })

  disabledChanged = () => this.setState({
    disabled: !this.state.disabled
  })

  valid = () => {

    const { accountToDebitDisb, accountToCreditDisb, accountToDebitRep, accountToCreditRep,
      accountToCreditVAT } = this.state,
    accountToDebitDisbState = validateTextState(accountToDebitDisb),
    accountToCreditDisbState = validateTextState(accountToCreditDisb),
    accountToDebitRepState = validateTextState(accountToDebitRep),
    accountToCreditRepState = validateTextState(accountToCreditRep),
    accountToCreditVATState = validateTextState(accountToCreditVAT)

    this.setState({
      accountToDebitDisbValidationState: accountToDebitDisbState,
      accountToCreditDisbValidationState: accountToCreditDisbState,
      accountToDebitRepValidationState: accountToDebitRepState,
      accountToCreditRepValidationState: accountToCreditRepState,
      accountToCreditVATValidationState: accountToCreditVATState
    })

    return (
      accountToDebitDisbState === VALIDATION_TYPE.SUCCESS &&
      accountToCreditDisbState === VALIDATION_TYPE.SUCCESS &&
      accountToDebitRepState === VALIDATION_TYPE.SUCCESS &&
      accountToCreditRepState === VALIDATION_TYPE.SUCCESS &&
      accountToCreditVATState === VALIDATION_TYPE.SUCCESS
    )
  }

  saveData = () => {

    this.setState({ closeStatuses: false })

    if(!this.valid()) {
      this.setState({ error: 'Some fields are incorrect.' })
      return
    }

    const { accountToDebitDisb, accountToCreditDisb, accountToDebitRep,
      accountToCreditRep, accountToCreditVAT, disabled } = this.state,
    data = {
      accountToDebitOnDisbursal: { id: accountToDebitDisb },
      accountToCreditOnDisbursal: { id: accountToCreditDisb },
      accountToDebitOnRepayment: { id: accountToDebitRep },
      accountToCreditOnRepayment: { id: accountToCreditRep },
      accountToCreditVAT: { id: accountToCreditVAT },
      useSellingCost: true,
      disabled,
    }

    this.setState({
      running: true,
      error: null,
      success: false,
    })

    blockingFetchService(
      accessToken => apiServerApi.saveCustomLoanAccountingRule(accessToken, data),
      _ => {
        this.setState({ success: true })
        this.timeOutId = setTimeout(() => {
          this.setState({ success: false })
          browserHistory.push(this.uri)
        }, 2000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  getLabel = (text, tooltip) => (
    <h4>
      { text }&nbsp;
      <OverlayTrigger placement="top" overlay={ <Tooltip id="helpTextAccount">{ tooltip }</Tooltip> }>
        <FontAwesome name='question-circle' className="green" />
      </OverlayTrigger>
    </h4>
  )

  renderForm = () => {

    const { accountToDebitDisb, accountToCreditDisb, accountToDebitRep, accountToCreditRep,
      accountToCreditVAT, disabled, accountToDebitDisbValidationState,
      accountToCreditDisbValidationState, accountToDebitRepValidationState,
      accountToCreditRepValidationState, accountToCreditVATValidationState } = this.state,

    { glAccounts } = this.props,

    glAccountsData = glAccountsDataWithId(glAccounts),

    tooltipLoanCreation = `Accounts that are used during loan disbursals.`,

    tooltipLoanRepayment = `Accounts that are used during loan repayments.`

    return <Form horizontal onSubmit={e => { e.preventDefault(); this.saveData() }}>

      { this.getLabel('Loan disbursals', tooltipLoanCreation) }
      <FormControlInlineSelect
        controlId='accountToDebitDisb' validationState={ accountToDebitDisbValidationState }
        label='Account to debit (VAT Incl.)' value={ accountToDebitDisb } 
        onChange={ this.accountToDebitDisbChanged }
        options={ glAccountsData }
        withEmptyOption={ true }
        helpText={ accountToDebitDisbValidationState === VALIDATION_TYPE.ERROR ? 'Choose an account' : '' }
        disabled={ !this.isUpdate }
      />

      <FormControlInlineSelect
        controlId='accountToCreditDisb' validationState={ accountToCreditDisbValidationState }
        label='Account to credit (Net price)' value={ accountToCreditDisb } 
        onChange={ this.accountToCreditDisbChanged }
        options={ glAccountsData }
        withEmptyOption={ true }
        helpText={ accountToCreditDisbValidationState === VALIDATION_TYPE.ERROR ? 'Choose an account' : '' }
        disabled={ !this.isUpdate }
      />

      <FormControlInlineSelect
        controlId='accountToCreditVAT' validationState={ accountToCreditVATValidationState }
        label='Account to credit (VAT)' value={ accountToCreditVAT } 
        onChange={ this.accountToCreditVATChanged }
        options={ glAccountsData }
        withEmptyOption={ true }
        helpText={ accountToCreditVATValidationState === VALIDATION_TYPE.ERROR ? 'Choose an account' : '' }
        disabled={ !this.isUpdate }
      />
      <hr />

      { this.getLabel('Loan repayments', tooltipLoanRepayment) }
      <FormControlInlineSelect
        controlId='accountToDebitRep' validationState={ accountToDebitRepValidationState }
        label='Account to debit' value={ accountToDebitRep } 
        onChange={ this.accountToDebitRepChanged }
        options={ glAccountsData }
        withEmptyOption={ true }
        helpText='This account will be debited for upfront payments only.'
        disabled={ !this.isUpdate }
      />

      <FormControlInlineSelect
        controlId='accountToCreditRep' validationState={ accountToCreditRepValidationState }
        label='Account to credit' value={ accountToCreditRep } 
        onChange={ this.accountToCreditRepChanged }
        options={ glAccountsData }
        withEmptyOption={ true }
        helpText='This account will be credited during all repayments.'
        disabled={ !this.isUpdate }
      />

      <hr/>
      <FormControlInlineCheckbox
        controlId='disabled' label='Disabled'
        validationState={ VALIDATION_TYPE.NULL } value={ disabled }
        onChange={ this.disabledChanged }
        disabled={ !this.isUpdate }
      />

      <FormControlInlineCheckbox
        controlId='sellingCost' label='Use Selling Price'
        validationState={ VALIDATION_TYPE.NULL } value={ true }
        disabled={ true }
      />
    </Form>
  }

  renderContent = () => {

    const { running, error, success, closeStatuses } = this.state

    return (
    <div className="simple-form max-width-700 mx-auto mb-20">

      <div className="flex-row flex-wrap">

        <p className="hot-color">
          <FontAwesome name='info-circle' /> &nbsp; { this.info }
        </p>

        { !this.isUpdate && (
        <ButtonUpdate
          onClick={() => browserHistory.push(this.uri + '/edit')}
          running={ running }
        />)}
      </div>
      <hr/>

      { this.renderForm() }

      <CloseableProcessesStatus
        error={ error }
        success={ success }
        close={ closeStatuses }
        handleClose={() => this.setState({ closeStatuses: true })}
      />

      { this.isUpdate && (
      <FormButtons onSave={ this.saveData } 
        onCancel={() => browserHistory.push(this.uri)} 
        running={ running }
      />)}
    </div>
  )}

  render() {
    const dataBreadCrumbs = [{ url: '/accounting', title: 'Accounting' }]

    return (
      <div>
        <CustomBreadCrumb activeText={ this.text } data={ dataBreadCrumbs } />
        { this.renderContent() }
      </div>
    )
  }
}

const mapStateToProps = state => {
  const glAccounts = DckSelectors.selectAllItems(state, ItemTypes.GLAccount)
  sortGLAccounts(glAccounts)
  return { glAccounts }
},

mapDispatchToProps = dispatch => ({
  loadGlAccounts: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.GLAccount)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomAccountingForm)



// WEBPACK FOOTER //
// ./src/components/Accounting/CustomAccountingRules/Form.js